// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__0sksu","button":"SearchBar_button__wfhyD","mobileVisible":"SearchBar_mobileVisible__u+ZmF"};